export default "__VITE_ASSET__5a97ad65__"